<!-- Then put toasts within -->
<div class="toast show top-right" role="alert" aria-live="assertive" aria-atomic="true" (click)="onClickDiv()">
    <div class="toast-body">
        <app-alert [properties]="alertProperties"></app-alert>
    </div>
</div>